import { render, staticRenderFns } from "./OrderSearchForm.vue?vue&type=template&id=b788ef98&scoped=true"
import script from "./OrderSearchForm.vue?vue&type=script&lang=ts"
export * from "./OrderSearchForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderSearchForm.vue?vue&type=style&index=0&id=b788ef98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b788ef98",
  null
  
)

export default component.exports